import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {IWindow} from "../../index";
const qs = require('qs');

const IWindow: IWindow = (window as IWindow);
import {Col, Container, Row} from "reactstrap";
import {api} from "../../api";

export class PartyIncidenceFormData {
}

export class PartyIncidenceForm extends CrudForm {
    modelName = 'PartyIncidencePage';
    renderFields() {
        return (
            <></>
        );
    }
}

export class PartyIncidenceFilterForm {
    @observable election_id = IWindow.initialState.route.params.id || null;
}

export class PartyIncidenceList extends CrudList {
    modelName = 'PartyIncidence';
    @observable election: any = null;

    constructor(props: any) {
        super(props);
        this.handleExport = this.handleExport.bind(this);
    }

    loadMoreData() {
        this.filterFormStore.getValue('election_id') &&
        api.election.getDetailAction(this.filterFormStore.getValue('election_id')).then((data: any) => {
            this.election = data;
        });
    }

    handleExport = () => {
        let search = {
            filters: this.filterFormStore.data,
            export: true
        };
        window.location.href = '/api/party-incidence-list?' + qs.stringify(search);
    };

    colums() {
        return [
            {
                name: "station_number",
                label: "Station Number",
            },
            {
                name: "state",
                label: "State",
            },
            {
                name: "lga",
                label: "LGA",
            },
            {
                name: "ward",
                label: "Ward",
            },
            {
                name: "pu_code",
                label: "PU Code",
            },
            {
                name: "polling_unit",
                label: "PU Name",
            },
            {
                name: 'remarks',
                label: "Incidence Remarks",
                formatter: (value: any) => {
                    return (
                        <>
                            { value.length > 50 ? value.slice(0, 50) + '...' : value    }
                        </>
                    )
                }
            },
            {
                name:'datetime',
                label: "Incidence Recorded at",

            },
            {
                name:'uploaded_by',
                label: "Recorded By",
            },
            {
                name:'url',
                label: "Document",
                formatter: (value: any, item: any) => {

                    return (
                        <>
                            { value ?  <a href={value} download="true" key={item.datetime + item.station_number}>Download</a>  : null }
                        </>
                    );
                },
            }
        ];
    }

    idColumn() {
        return '';
    }

    actions() {
        return {}
    }

    renderFilters() {
        if(!this.election){
            return '';
        }
        return (

            <Container>
                <Row className="form-row">
                    <Col md={12} className="grid-search">
                        <div className={'d-flex'}>
                            <label className={'p-3 bg-light rounded mr-2'}>{this.election.election_type.name}</label>
                            <label className={'p-3 bg-light rounded mr-2'}>{this.election.name}</label>
                            <label className={'p-3 bg-light rounded mr-2'}>{this.election.election_at}</label>
                        </div>
                    </Col>
                </Row>

                <Row className="form-row">
                    <Col md={2} lg={3} xl className="grid-search">
                        {this.renderSearch()}
                    </Col>
                    <Col md={1} className="grid-search">
                        <button className="btn btn-dark" onClick={this.handleExport}>Export</button>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export class PartyIncidencePage extends CrudPage {
    modelName = 'PartyIncidence';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PartyIncidencePage.tsx